import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { Title } from '../shared';
import Wrapper from '../shared/errors/wrapper';

const NotFound = () => {
  return (
    <Route
      render={({ staticContext }) => {
        if (staticContext) {
          staticContext.statusCode = 404;
        }
        return (
          <Fragment>
            <Title description={'Page was not found'} title={`Page not found`} />
            <Wrapper title={'Page not found'} />
          </Fragment>
        );
      }}
    />
  );
};

export default NotFound;
